import React, { forwardRef } from 'react';
import { styleIcon } from '../style_icon.js';
export const RowDensityCozyIcon = forwardRef(({ title = 'Row Density Cozy Icon', ...rest }, ref) => {
    const props = styleIcon(rest);
    return (React.createElement("svg", { ...props, ref: ref, viewBox: "0 0 14 14" },
        !props['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M0 3V.5C0 .22.22 0 .5 0h13c.28 0 .5.22.5.5V3a.5.5 0 0 1-.5.5H.5A.5.5 0 0 1 0 3m.5 5.75h13a.5.5 0 0 0 .5-.5v-2.5a.5.5 0 0 0-.5-.5H.5a.5.5 0 0 0-.5.5v2.5c0 .28.22.5.5.5M.5 14h13a.5.5 0 0 0 .5-.5V11a.5.5 0 0 0-.5-.5H.5a.5.5 0 0 0-.5.5v2.5c0 .28.22.5.5.5" })));
});
//# sourceMappingURL=row_density-cozy_icon.js.map